import React, { memo, useCallback, useEffect, useState } from 'react';
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment-timezone';
import {getDateFormat, getUserTimeZone} from '../../../../Utils/UserFunctions';
import {isSet} from '../../../../Utils/CommonFunctions';
import {correctSegmentValue, getDefaultValue, getSegmentPositions, shouldPad} from '../../../../Utils/DateUtils';
import MomentUtils from '@date-io/moment';
import {
  KeyboardDatePicker,
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";

const detectDateFormat = (dateString) => {
  const dateFormats = [
    getDateFormat(),
    'YYYY-MM-DD HH:mm:ss.S'
  ];
  const matchedFormat = dateFormats.find(format => moment(dateString, format, true).isValid());
  return matchedFormat || 'Unknown format';
};


const DatePick = (props)=>{
  const  {
    item,
    className,
    validationForms,
    sectionType,
    fieldObj
  } = props;
  const dateFormat =() => isSet(getDateFormat(), 'YYYY-MM-DD HH:mm:ss.S');


  /*const getDateTimeFormat = 'YYYY-MM-DD 00:00:00.0';//'YYYY-MM-DD HH:mm:ss.S';
  const putDateTimeFormat = 'YYYY-MM-DD 00.00.00.0';//'YYYY-MM-DD HH:mm:ss.S';*/
  const getDateTimeFormat = dateFormat();
  useEffect(()=>{
      if(!item.overridden && props.layoutForms){
        let defaultValue = null;
        if(isSet(item.default_value,null)!==null && !item.overridden && isSet(item.selectedValue,null)===null){
            const splitDefautDate = item.default_value.split(' ');
            if(splitDefautDate[0]==='Today'){
             defaultValue = moment().format(getDateTimeFormat);
            }else{
              defaultValue = moment().subtract(splitDefautDate[0], splitDefautDate[1]).format(getDateTimeFormat);
          
            }
        }
        // console.log('defaultValue',defaultValue);
        if(defaultValue!==null){
          props.onChangeInputAction(fieldObj,defaultValue,'date');
        }
      }
  },[item.overridden]);
  
  const onChangeDate = useCallback((moment)=>{
    // console.log('moment',moment);
    if (isSet(moment,null)!==null &&  typeof moment.format === "function" && props.layoutForms) {
      // console.log('moment',moment.startOf('day').format(dateFormat()));
        props.onChangeInputAction(fieldObj,moment.startOf('day').format(dateFormat()),
        'date');
        // setDateTimeFormat(dateFormat());
      }else if(props.layoutForms || isSet(moment,null)===null){
          props.onChangeInputAction(fieldObj,
            (isSet(moment,null)===null)?null:moment.startOf('day').format(dateFormat()),
            'date');
            // setDateTimeFormat(dateFormat());

      } 
   });
   
   const materialTheme = createTheme({
    palette: {primary: blue},
  });

    const attr = formFieldsAttributes(
      {...item,default_value:null,className:className
    },validationForms);

    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
      readonlyVal = attr.fieldAttributes.readOnly;
    }

    let displayDate =  (isSet(attr.value,null)!==null && isSet(attr.value,null)!=='Invalid date')?moment(attr.value, detectDateFormat(attr.value), true):null;
    
    const handleKeyDown = (e) => {
      const input = e.target;
      const key = e.key;
      const format = dateFormat();
      // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
      const segments = getSegmentPositions(format);
      let cursor = input.selectionStart;
      let value = input.value || getDefaultValue(format);

      const isDigit = /^\d$/.test(key);
      const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);
      let didPad = false;

      const currentSegment = segments.find(seg => cursor >= seg.start && cursor <= seg.end);
      if (!currentSegment) return;

      const segIndex = segments.indexOf(currentSegment);
      const { start: segStart, end: segEnd } = currentSegment;
      const segLength = segEnd - segStart;
      const segVal = value.slice(segStart, segEnd);

      // Prevent editing separator directly
      if (!isDigit && !isControl) {
        e.preventDefault();
        return;
      }

      if (isDigit) {
        e.preventDefault();

        let positionInSegment = cursor - segStart;
        let segChars = segVal.split('');
        const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');

          // 👇 If segment is full, start fresh on first key press
          if (isSegmentFullyFilled && positionInSegment === 0) {
            segChars = Array(segLength).fill('_');
          }

        // Shift left and insert new key at cursor
        segChars.splice(positionInSegment, 0, key);
        segChars = segChars.slice(0, segLength); // Ensure segment length
        const rawUpdated = segChars.join('').replace(/_/g, '');

        const segmentType = currentSegment.type;
        const digitsOnly = value.replace(/[^\d]/g, '');

        // Auto-pad logic
        if (shouldPad(segmentType, rawUpdated, digitsOnly)) {
          segChars = rawUpdated.padStart(segLength, '0').split('');
        }

        let updatedSegment = segChars.join('').padEnd(segLength, '_');
        // const digitsOnly = value.replace(/[^\d]/g, '');
        
        if (shouldPad(currentSegment.part, updatedSegment.replace(/_/g, ''), segChars.join(''))) {
          // updatedSegment = updatedSegment.replace(/_/g, '').padStart(segLength, '0');
          const corrected = correctSegmentValue(currentSegment.part, updatedSegment, digitsOnly);
          updatedSegment = corrected.padEnd(segLength, '_');
        
          didPad = true;

        }
        // console.log('currentSegment',updatedSegment);
        value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
        input.value = value;

        const newCursor = segStart + positionInSegment + 1;

        queueMicrotask(() => {

          // if (newCursor < segEnd) {
          //   input.setSelectionRange(newCursor, newCursor);
          // } else if (segIndex < segments.length - 1) {
          //   const next = segments[segIndex + 1];
          //   input.setSelectionRange(next.start, next.end);
          // } else {
          //   input.setSelectionRange(segStart, segEnd);
          // }
          if (didPad && segIndex < segments.length - 1) {
            // Move to next segment if padding was applied
            const next = segments[segIndex + 1];
            input.setSelectionRange(next.start, next.end);
          } else {
            // const newCursor = segStart + positionInSegment + 1;
            if (newCursor < segEnd) {
              input.setSelectionRange(newCursor, newCursor);
            } else if (segIndex < segments.length - 1) {
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
            } else {
              input.setSelectionRange(segStart, segEnd);
            }
          }
        });

        const momentDate = moment(value, format, true);
        if (momentDate.isValid()) {
          onChangeDate?.(momentDate);
        }

        return;
      }

      if (key === 'Backspace') {
        e.preventDefault();

        let newValue = value;
        let newCursor = cursor;
        let currentIndex = segIndex;

        // Iterate segments backward if already cleared
        while (currentIndex >= 0) {
          const seg = segments[currentIndex];
          const segVal = newValue.slice(seg.start, seg.end);
          const isCleared = /^[_\s]*$/.test(segVal);

          if (!isCleared) {
            const cleared = '_'.repeat(seg.end - seg.start);
            newValue = newValue.slice(0, seg.start) + cleared + newValue.slice(seg.end);
            newCursor = seg.start;
            break;
          }
          currentIndex--;
        }

        input.value = newValue;
        queueMicrotask(() => {
          input.setSelectionRange(newCursor, newCursor);

          const digitsOnly = newValue.replace(/[^\d]/g, '');
          const allCleared = digitsOnly.length === 0;
          if (allCleared) {
            onChangeDate(null);
          }
        });
        return;
        // e.preventDefault();
        // const cleared = '_'.repeat(segLength);
        // input.value = value.slice(0, segStart) + cleared + value.slice(segEnd);
        // requestAnimationFrame(() => {
        //   input.setSelectionRange(segStart, segEnd);
        //   // console.log('input.value',input.value);
        //   const digitsOnly = value.replace(/[^\d]/g, '');
        //   const allCleared = digitsOnly.length === 0;
        //   // console.log('allCleared',allCleared,digitsOnly);
        //   if (allCleared) {
        //     onChangeDate(null);
        //   }
        // });
        // return;
      }

      if (key === 'ArrowRight' && segIndex < segments.length - 1) {
        e.preventDefault();
        const next = segments[segIndex + 1];
        input.setSelectionRange(next.start, next.end);
        return;
      }

      if (key === 'ArrowLeft' && segIndex > 0) {
        e.preventDefault();
        const prev = segments[segIndex - 1];
        input.setSelectionRange(prev.start, prev.end);
        return;
      }
    };
    
  // console.log('segments',getDefaultValue(format));
    const handleFocusOrClick = (e) => {
    const format = dateFormat();
    const input = e.target;

    if (!input.value) {
      input.value = getDefaultValue(format);
      try {
        input.setSelectionRange(0, 0);
      } catch (e) {
        // handle error silently
      }
    } else {
      const segments = getSegmentPositions(format);
      const cursor = input.selectionStart || 0;
      const seg = segments.find(s => cursor >= s.start && cursor <= s.end) || segments[0];
      try {
        input.setSelectionRange(seg.start, seg.end);
      } catch (e) {
        // handle error silently
      }
    }
  };

  // initialFocusedDate: when empty, open picker on current date in user's timezone
  const initialFocusedDate =
    (isSet(displayDate, null) !== null && isSet(displayDate, null) !== '')
      ? displayDate
      : moment.tz(getUserTimeZone());

    return (
    <FormBlocks attr={attr} {...props} item={item} sectionType={sectionType}>
      <ThemeProvider theme={materialTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils} >
            <KeyboardDatePicker
              fullWidth
              keyboard
              clearable
              inputReadOnly={false}
              margin="normal"
              defaultValue={null} 
              value={displayDate}
              initialFocusedDate={initialFocusedDate}
              // disablePast
              onChange={onChangeDate}
              label=""
              // clearable={true}
              InputProps={{
                className:'form-control',
                style: {fontSize: '0.8rem'},
                disableUnderline: true,
                ...attr.fieldAttributes,
                autoComplete:'off',
                placeholder: dateFormat(),
                onFocus:handleFocusOrClick,
                onClick:handleFocusOrClick,
                onKeyDown:(e)=>{handleKeyDown(e)}
                // onKeyDown: (e) => restrictDateInput(e, dateFormat()),
                // onKeyDown:(e) => handleDateKey(e, dateFormat()),

                // onClick:(e) => handleSegmentFocus(e,dateFormat()),
                // onFocus:(e) => handleSegmentFocus(e,dateFormat())
              }}
              readOnly={readonlyVal} 
              //  variant={'inline'}       
              // showTodayButton 
              format={dateFormat()}
              autoOk={true}
              className="MuiFormControl-Custom"
              // emptyLabel={dateFormat()}
              />
              
              
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    </FormBlocks>
  )  
}


DatePick.defaultProps = {
className:'form-control'
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(DatePick,isDiffProps);